import React, { Fragment, useState } from "react";

import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  useTheme,
} from "@mui/material";
import { useCallback } from "react";
import { useTranslation } from "react-i18next";

const DialogComponent = ({
  button = "Open alert dialog",
  content,
  onClickYes = () => {},
}) => {
  const { t } = useTranslation();
  const theme = useTheme();
  const [open, setOpen] = useState(false);

  const handleClickOpen = useCallback(() => {
    setOpen(true);
  }, []);

  const handleCloseYes = useCallback(() => {
    onClickYes();
    setOpen(false);
  }, [onClickYes]);

  const handleClose = useCallback(() => {
    setOpen(false);
  }, []);

  return (
    <Fragment>
      <Box onClick={handleClickOpen}>{button}</Box>

      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">{t("Elimination")}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            {content}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={handleClose}
            sx={{ color: theme.palette.mode === "dark" ? "white" : "black" }}
          >
            No
          </Button>
          <Button onClick={handleCloseYes} autoFocus color="secondary">
            {t("Yes")}
          </Button>
        </DialogActions>
      </Dialog>
    </Fragment>
  );
};
export default DialogComponent;
